module.exports = __webpack_public_path__ + "img/J8.dda2afb9.webp";